var controller = new ScrollMagic.Controller();
var tl = new TimelineMax();



$(function() {



  if($('.top-bg-video').length){
    objectFitImages();
  }
  if($('#progress-bar').length){
    TweenMax.fromTo('#progress-bar', 1,{
    width: 0},
    {
    width: '100%',
    //delay:1,
    yoyo: true,
    onComplete: function(){
      setTimeout(function(){
      $('body').addClass('is-loaded');
    },2000);
    }
  },1
    );

  }






  if($('.page-common-navigation').length){

    var headerHeight = $('#site-header').outerHeight();
    var urlHash = location.hash;
    if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
            var target = $(urlHash);
            var position = target.offset().top - headerHeight;
            $('body,html').stop().animate({scrollTop:position}, 800);
        }, 100);
    }
    $('.page-common-navigation a[href^="#"]').on('click',function() {
        var href= $(this).attr("href");
        var target = $(href);
        var position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, 800);
    });


  }

  if($('.slideUp').length){
    $(".slideUp").each(function() {
      var tl = new TimelineMax();
      tl.fromTo(this, 1, {
        autoKill: false,
      }, {
        autoKill: false,
        className: "+=slideUp-on",
      });

      new ScrollMagic.Scene({
          triggerElement: this,
          duration:400,
          reverse: false,
triggerHook: .75,        })
        .setTween(tl).addTo(controller)

    });
  }
  if($('.fadeIn').length){
      $(".fadeIn").each(function() {
        var tl = new TimelineMax();
        tl.fromTo(this, 1, {
          autoKill: false,
        }, {
          autoKill: false,
          className: "+=fadeIn-on",
        });
        new ScrollMagic.Scene({
            triggerElement: this,
            duration:400,
            reverse: false,
triggerHook: .75,          })
          .setTween(tl).addTo(controller)
      });
  }
  if($('.fadeUp').length){
      $(".fadeUp").each(function() {
        var tl = new TimelineMax();
        tl.fromTo(this, 1, {
          autoKill: false,
        }, {
          autoKill: false,
          className: "+=fadeUp-on",
        });
        new ScrollMagic.Scene({
            triggerElement: this,
            duration:400,
            reverse: false,
triggerHook: .75,          })
          .setTween(tl).addTo(controller)
      });
  }
  if($('.scaleUp').length){
      $(".scaleUp").each(function() {
        var tl = new TimelineMax();
        tl.fromTo(this, 1, {
          autoKill: false,
        }, {
          autoKill: false,
          className: "+=scaleUp-on",
        });
        new ScrollMagic.Scene({
            triggerElement: this,
            duration:400,
            reverse: false,
triggerHook: .75,          })
          .setTween(tl).addTo(controller)
      });
  }
  if ($('.fadeUpY').length) {
      $(".fadeUpY").css({
        opacity: 0
      }).each(function(i) {
        var fadeUpY = new ScrollMagic.Scene({
          triggerElement: this,
          reverse: false,
          triggerHook: .75,
        })
        fadeUpY.setVelocity(this, {
            opacity: 1,
            translateY: 0
          }, {
            duration: 1250,
            delay: 50 * i,
          })
          .addTo(controller);
      });
  }


  /***************************************************
  アコーディオン SHOPLIST
  ***************************************************/
  if ($('#shoplist-contents .acc-toggle').length) {
    function accordionAll() {
    $(this).toggleClass("active").next('.acc-item').slideToggle();
    }
    $("#shoplist-contents .acc-toggle").click(accordionAll);
  }

});






if ($('.parallax').length) {
  Parallax.init('.parallax');
}

var topBtn = $('#pagetop');
    topBtn.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });

    topBtn.on('click',function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });



var headClrHeight = $('#intro').outerHeight(true);
var headClr = new ScrollMagic.Scene({
        triggerElement: "#top-bogo",
        reverse: false,
        triggerHook: .85,
        //duration: headClrHeight,
})
.addTo(controller)
.setClassToggle("#top-bogo", "is-active") // add class toggle

if( $('#top-bogo').length ) {
  var controller = new ScrollMagic.Controller();

  $(".is-randum-anime").each(function() {
    var ramAnimeTxt = $(this).find('span i').toArray();
    var ramAnimeNum = $(this).find('span i').toArray();
    var tl = new TimelineMax();


    TweenMax.set(ramAnimeTxt, {
      autoAlpha: 0,
      y: 30,

    });
    ramAnimeTxt.sort(function() {
      return 0.5 - Math.random()
    });
    var randumTtl = TweenMax.staggerTo(ramAnimeTxt, 1, {
      autoAlpha: 1,
      y: 0,
      ease: Quad.easeInOut,
    }, 0.05);
      new ScrollMagic.Scene({
          reverse: false,
          triggerElement: '#top-bogo',
          triggerHook: .75,

        })
        .setTween(randumTtl).addTo(controller)
  });



  var bogoRead = TweenMax.staggerFromTo(".bogo-box .read i", 3, {
      autoAlpha: 0,
      y: 30,
    }, {
      autoAlpha: 1,
      y: 0,
    }, .15);
  new ScrollMagic.Scene({
      triggerElement: '#top-bogo',
      reverse: false,
  triggerHook: .75,  })
    .setTween(bogoRead).addTo(controller)




}





jQuery( window ).on( 'scroll', function() {
  if ( 400 < jQuery( this ).scrollTop() ) { // 1000px以上スクロールしたら
    jQuery( 'body' ).addClass( 'js-header-fixed' );
  } else {
    jQuery( 'body' ).removeClass( 'js-header-fixed' );

  }
});

if ($('.topic-swiper-container').length) {
  var topicproduct = new Swiper('.topic-swiper-container', {
    loop: false,
    speed:1500,
    spaceBetween: 20,
    slidesPerView: 4,
    slidesPerGroup: 1,
    centeredSlides: false,
    grabCursor: false,
    navigation: {
      nextEl: '.topic-next',
      prevEl: '.topic-prev'
    },
    pagination: {
      el: '.topic-swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      767: {
        loop: false,
        slidesPerGroup: 1,
        slidesPerView: 1.15,
        spaceBetween: 10,
        centeredSlides: true,

      },
    }

  });
}

if ($('.voice-swiper-container').length) {
  var topicproduct = new Swiper('.voice-swiper-container', {
    loop: true,
    speed:4000,
    autoplay: {
      delay: 4000,
      reverseDirection: true,
      disableOnInteraction: false,
    },
    effect: 'fade',
    spaceBetween: 0,
    slidesPerView: 1,
    centeredSlides: true,
    grabCursor: false,
  });
}
if ($('.fv-swiper-container').length) {
  var interleaveOffset = 1;
  var swiperOptions = {
    loop: true,
    autoplay: {
      delay: 4000,
      reverseDirection: true,
      disableOnInteraction: false,
    },
    reverseDirection: true,
    speed: 2500,
    grabCursor: false,
    watchSlidesProgress: true,
    mousewheelControl: false,
    keyboardControl: true,
    pagination: {
      el: '.fv-swiper-pagination',
      type: 'bullets',
    },
    on: {
      slideChange: function() {
        $(function() {
          //$('div.swiper-num .current').text(swiperNew.realIndex + 1);
          //$('div.swiper-num .total').text(swiperNew.slides.length - 2);
          if ($('#progress').length) {
            //slide_progress();
          }
        });
      },
      progress: function() {
        var swiper = this;
        for (var i = 0; i < swiper.slides.length; i++) {
          var slideProgress = swiper.slides[i].progress;
          var innerOffset = swiper.width * interleaveOffset;
          var innerTranslate = slideProgress * innerOffset;
          swiper.slides[i].querySelector(".slide-inner").style.transform =
            "translate3d(" + innerTranslate + "px, 0, 0)";
        }
      },
      touchStart: function() {
        var swiper = this;
        for (var i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = "";
        }
      },
      setTransition: function(speed) {
        var swiper = this;
        for (var i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = speed + "ms";
          swiper.slides[i].querySelector(".slide-inner").style.transition =
            speed + "ms";
        }
      }
    }
  };
  var swiperFV = new Swiper(".fv-swiper-container", swiperOptions);

}



$(function() {

  var swiper;
  $(window).on('load resize', function(){
      var w = $(window).width();
      if (w <= 1023) {
          if (swiper) {
              return;
          } else {
              swiper = new Swiper('.productList-swiper-container', {
                loop: true,
                speed:1500,
                spaceBetween: 20,
                slidesPerView: 1.75,
                slidesPerGroup: 1,
                centeredSlides: true,
                grabCursor: false,
                  pagination: {
                      el: '.swiper-pagination',
                      clickable: true,
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
              });
          }
      } else {
          if (swiper) {
              swiper.destroy();
              swiper = undefined;
          }
      }
  });

 });
$('#menu-toggle').on('click', function() {
    $('#menu-toggle').toggleClass('js-menu-active');
    $('body').toggleClass('js-menu-active');



    if(($('body').hasClass('js-menu-active'))) {
      $(".main-navigation").each(function() {
          var MegaMenuLeft = $(".main-navigation-wrapper-bg");
          var MegaMenuRight = $(".megamenu-visual-bg");
          var MegaMenuName = $(".main-navigation").find('.menu-block .menu>li .name em').toArray();
          var MegaMenuNum = $(".main-navigation").find('.menu-block .menu>li .num span').toArray();
          var MegaMenuSubMenu= $(".main-navigation").find('.menu-block .menu>li .sub-menu li a span').toArray();
          var MegaMenuLang= $(".main-navigation").find('.lang-wrapper');
          var MegaMenuSNS = $(".main-navigation").find('.sns-followus');
          var MegaMenuCorpLink = $(".main-navigation").find('.corporate-link');
          TweenMax.fromTo('.megamenu-wrapper', .5,{
          height:"0%",
          },{
          yoyo: false,
          height:"100vh",
          className:"+=js-menu-active",
          },.15
          );

          TweenMax.fromTo(MegaMenuLeft, .85,{
          },
          {
          yoyo: false,

          className:"+=active",
          },.5
          );
          TweenMax.fromTo(MegaMenuRight, .85,{
          },
          {
          yoyo: false,
          delay:.15,
          className:"+=active",
        },.85
          );
          TweenMax.fromTo(MegaMenuName, .85,{
          y: 40},
          {
          y: 0,
          delay:.5,
          yoyo: false,
          },.5
          );

          TweenMax.fromTo(MegaMenuNum, .85,{
          y: 40},
          {
          y: 0,
          delay:.5,
          yoyo: false,
          },.5
          );
          TweenMax.fromTo(MegaMenuSubMenu, .85,{
          y: 40},
          {
          y: 0,
          delay:.6,
          yoyo: false,
        },.5
          );

          TweenMax.fromTo(MegaMenuLang, .85,{
          autoAlpha: 0,
          y: 40},
          {
          autoAlpha: 1,
          y: 0,
          delay:.7,
          yoyo: false,
        },.5
          );
          TweenMax.fromTo(MegaMenuSNS, .85,{
          autoAlpha: 0,
          y: 40},
          {
          autoAlpha: 1,
          y: 0,
          delay:.7,
          yoyo: false,
        },.5
          );
          TweenMax.fromTo(MegaMenuCorpLink, .85,{
          autoAlpha: 0,
          y: 40},
          {
          autoAlpha: 1,
          y: 0,
          delay:.7,
          yoyo: false,
        },.5
          );
          TweenMax.fromTo(".megamenu-logo span", .85,{
          y: 140},
          {
          y: 0,
          delay:.7,
          yoyo: false,
        },.5
          );

        })
    } else {

      $(".main-navigation").each(function() {
          var MegaMenuLeft = $(".main-navigation-wrapper-bg");
          var MegaMenuRight = $(".megamenu-visual-bg");
          var MegaMenuName = $(".main-navigation").find('.menu-block .menu>li .name em').toArray();
          var MegaMenuNum = $(".main-navigation").find('.menu-block .menu>li .num span').toArray();
          var MegaMenuSubMenu= $(".main-navigation").find('.menu-block .menu>li .sub-menu li a span').toArray();
          var MegaMenuLang= $(".main-navigation").find('.lang-wrapper');
          var MegaMenuSNS = $(".main-navigation").find('.sns-followus');
          var MegaMenuCorpLink = $(".main-navigation").find('.corporate-link');
          TweenMax.fromTo(".megamenu-logo span", .85,{
          y: 0},
          {
          y: -140,
          yoyo: false,
          },.5
          );
          TweenMax.fromTo(MegaMenuLang, .5,{
          autoAlpha: 1,
          y: 0},
          {
          autoAlpha: 0,
          y: -40,
          yoyo: false,
          },.5
          );
          TweenMax.fromTo(MegaMenuSNS, .5,{
          autoAlpha: 1,
          y: 0},
          {
          autoAlpha: 0,
          y: -40,
          yoyo: false,
          },.5
          );
          TweenMax.fromTo(MegaMenuCorpLink, .5,{
          autoAlpha: 1,
          y: 0},
          {
          autoAlpha: 0,
          y: -40,
          yoyo: false,
          },.5
          );
          TweenMax.fromTo(MegaMenuSubMenu, .85,{
          y: 0},
          {
          y: -40,
          yoyo: false,
          },.5
          );
          TweenMax.fromTo(MegaMenuNum, .85,{
          y: 0},
          {
          y: -40,
          yoyo: false,
          },.5
          );
          TweenMax.fromTo(MegaMenuName, .85,{
          y: 0},
          {
          y: -40,
          yoyo: false,
          },.5
          );
          TweenMax.fromTo(MegaMenuRight, .85,{
          },
          {
          yoyo: false,
          className:"-=active",
        },.85
          );
          TweenMax.fromTo(MegaMenuLeft, .85,{
          },
          {
          yoyo: false,
          className:"-=active",
        },.85
          );

          TweenMax.fromTo('.megamenu-wrapper', .5,{
          height:"100vh",
          },
          {
          yoyo: false,
          height:"0%",
          delay:.5,
          className:"-=js-menu-active",
          },.5
          );


        })

    }
    return false;
  })

/*
  $('.main-navigation li a').on('click', function() {
    $('#menu-toggle').removeClass('open');
    $('body').removeClass('menu-active');
  })
*/

  $('.main-navigation li a[href]').on('click', function() {
    $('#menu-toggle').trigger('click');
  });

  /********************************
  メディアクエリ
  *********************************/
  var mql = window.matchMedia('screen and (max-width: 1023px)');
  function checkBreakPoint(mql) {
    if (mql.matches) {

      $(function() {
        /*
        if($('.page-common-navigation').length){
          (function(abc) {
            abc(function() {
              $(".page-common-navigation").mCustomScrollbar({
                axis:"x",
                theme:"dark-thin",
                autoExpandScrollbar:false,
                advanced:{autoExpandHorizontalScroll:true}
              });
            });
          })(jQuery);
        }
        */
      });




      if ($('.productDetail-swiper-container').length) {
        var topicproduct = new Swiper('.productDetail-swiper-container', {
          breakpoints: {
            1023: {
              speed:1500,
              navigation: {
                nextEl: '.productDetail-next',
                prevEl: '.productDetail-prev'
              },
              pagination: {
                el: '.productDetail-swiper-pagination',
                clickable: true,
              },
              loop: true,
              slidesPerGroup: 1,
              slidesPerView: 1.25,
              spaceBetween: 3,
              grabCursor: true,
              centeredSlides: true,

            },
          }

        });
      }



        /***************************************************
        アコーディオン
        ***************************************************/
        if ($('.acc-toggle').length) {
          function accordionAll() {
          $(this).toggleClass("active").next('.acc-item').slideToggle();
          }
          $(".megamenu-wrapper .acc-toggle").click(accordionAll);
        }
        /***************************************************
        top fv video
        ***************************************************/
        if ($('#fv-video-sp').length) {

          setInterval(function(){
            $('.fv-video-wrapper').toggleClass('is-finished');
          },8000);


        /*
        var FvVideo = document.getElementById('fv-video-sp');
        var FvVideoWrap = document.getElementById('fv-video-wrapper');
        FvVideo.addEventListener('ended',myHandler,false);
          function myHandler(e) {
              FvVideoWrap.classList.add("is-finished");
          }
        */

        }

        /*
        var array = [
      		　'https://cdn.shopify.com/s/files/1/0471/5810/0126/files/video_carrythesun_kv01_sp.mp4',
      			'https://cdn.shopify.com/s/files/1/0471/5810/0126/files/video_carrythesun_kv02_sp.mp4',
      		];

      	var l = array.length;
      	var r = Math.floor(Math.random()*l);
      	var bgimgurl = array[r];
      	$("#fv-video").attr('src',''+bgimgurl+'');
        */

      } else {
        /***************************************************
        top fv video
        ***************************************************/

        if ($('#fv-video-pc').length) {

          setInterval(function(){
            $('.fv-video-wrapper').toggleClass('is-finished');
          },8000);

          /*
          var FvVideo = document.getElementById('fv-video-pc');
          var FvVideoWrap = document.getElementById('fv-video-wrapper');
          FvVideo.addEventListener('ended',myHandler,false);
          function myHandler(e) {
              FvVideoWrap.classList.add("is-finished");
          }
          */
          }

        /*
        var array = [
      		　'https://cdn.shopify.com/s/files/1/0471/5810/0126/files/video_carrythesun_kv01.mp4',
      			'https://cdn.shopify.com/s/files/1/0471/5810/0126/files/video_carrythesun_kv02.mp4',
      		];

      	var l = array.length;
      	var r = Math.floor(Math.random()*l);
      	var bgimgurl = array[r];
      	$("#fv-video").attr('src',''+bgimgurl+'');
        */

      }


  }

  mql.addListener(checkBreakPoint);
  checkBreakPoint(mql);
